import { IconProps } from "./";
import Icon from "./assets/file_folder_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24FileFolder(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
